/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // const filterItems = document.querySelector('.collection__filters-active__wrapper .filter-items');
  // if (filterItems && filterItems.children.length === 1) {
  //   filterItems.remove();
  // }

    if (window.customJSLoaded) {
      console.log("CUSTOM JS ALREADY LOADED");
      return;
    }

    window.customJSLoaded = true;
    console.log("CUSTOM JS LOADED");

   const filterItems = document.querySelectorAll('.collection__filters-active__wrapper .filter-items');

  filterItems.forEach(item => {
    const visibleFilters = item.querySelectorAll('.collection__filters-active__filter');
    if (visibleFilters.length === 1) {
      visibleFilters[0].style.display = 'none';
      item.style.display = 'none';
    }
  });

  // 
   const installmentsCta = document.querySelector(".product-form__shopify-payment-terms button");
  if (installmentsCta) installmentsCta.remove();

  // 

 if (window.location.pathname === '/pages/returns-and-exchanges-1' && 
    !window.location.search.includes('view=returns-custom')) {
    window.location.href = '/pages/returns-and-exchanges-1?view=returns-custom';
  } 

     // Get all trigger elements
  const triggerLinks = document.querySelectorAll('.header-trigger__link.header-trigger__link--mobile');
  
  // Add click event to each trigger
  triggerLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default link behavior
      // Toggle is-open class on the clicked link
      this.classList.toggle('is-open');
      // Get the modal and toggle its is-open class
      const modal = document.getElementById('modal-main-menu');
      if (modal) {
        modal.classList.toggle('is-open');
        document.querySelector('body').classList.toggle('is-hidden');
      }
    });
  });

});
// document.querySelectorAll('.product-form__shopify-payment-terms button').forEach(btn => btn.remove());
document.addEventListener('click', function (event) {
  const searchLink = event.target.closest(
    '.secondary-nav__link.secondary-nav__link--search.secondary-nav__link--icon'
  );

  if (searchLink) {
    const modal = document.getElementById('modal-search');
    if (modal && !modal.classList.contains('is-open')) {
      modal.classList.add('is-open');
    }
  }
  if (event.target.closest('#modal-search .modal__close')) {
    const modal = document.getElementById('modal-search');
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
  }
});

// Insert any custom theme js here...